import type { ReactNode } from "react";
import { Label } from "../../../../../components";

export type CommonProps = {
  isSubmitting: boolean;
  canEditField: (field: string) => boolean;
};

export type Option = { label: string; value: string };

export const renderError = (message?: string) =>
  message ? <p className="mt-1 text-sm text-red-500">{message}</p> : null;

export const RequiredLabel = ({
  children,
  className = "",
  required = true,
}: {
  children: ReactNode;
  className?: string;
  required?: boolean;
}) => (
  <Label className={`font-semibold text-slate-700 dark:text-slate-200 ${className}`.trim()}>
    {children}
    {required ? (
      <>
        <span
          className="ml-1 text-red-500"
          aria-hidden="true"
        >
          *
        </span>
        <span className="sr-only"> (required)</span>
      </>
    ) : null}
  </Label>
);

export const SectionTitle = ({ children, icon }: { children: ReactNode; icon?: ReactNode }) => (
  <div className="mb-5 flex items-center gap-2.5">
    {icon ? (
      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600 dark:bg-emerald-950/50 dark:text-emerald-400">
        {icon}
      </span>
    ) : null}
    <Label className="block text-base font-bold text-slate-900 dark:text-slate-100">
      {children}
    </Label>
  </div>
);
